import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

interface UneditableInputProps extends Styled {
  label?: string;
  text: string;
}

export const UneditableInput = ({
  label,
  text,
  className,
}: UneditableInputProps) => {
  return (
    <div className={twMerge("flex flex-col overflow-hidden", className)}>
      {label && (
        <span className="mb-2 text-left text-neutral-variant-50 dark:text-tertiary">
          {label}
        </span>
      )}
      <div className="rounded-xl border border-neutral-variant-30 bg-surface-container-high px-4 py-3.5 text-left text-neutral-variant-70 dark:bg-surface-container-high-dark">
        <span className="flex truncate text-left">{text}</span>
      </div>
    </div>
  );
};
